import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store'
import { routers, routerCommon } from './router'
import routerMap from './routerMap'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: routers
})

router.beforeEach((to, from, next) => {
  // debugger
  if (to && Array.isArray(to.matched)) {
    to.matched.filter(item => item.path === to.path).forEach(item => {
      if (item.props && item.props.default) {
        if (item.props.default.moduleCode) {
          to.params.moduleCode = item.props.default.moduleCode
        }
      }
    })
  }
  // debugger
  // 如果去登录页,则直接跳登录页
  if (to.name === '登录') {
    next()
  } else if (to.name === '忘记密码') {
    next()
  } else if (store.getters['login/isLoggedin']) {
    if (!store.state.permission.hasGetRules) {
      // 验证token是否有效
      store.dispatch('login/init').then(result => {
        if (result) {
          // store.dispatch('permission/getResourceListByRoleName').then(rules => {
          //   router.addRoutes([rules])
          //   const homePage = store.state.permission.homePage
          //   // 判断是否输入空地址，若为空且已经登录则跳转首页
          //   if (to.path === '/') {
          //     next({ path: homePage, replace: true })
          //   } else {
          //     next({ ...to, replace: true })
          //   }
          // }).catch(() => {
          //   next({ name: '登录' })
          // })

          const routerCommonChild = routerCommon.children.concat(routerMap)
          routerCommon.children = routerCommonChild
          router.addRoutes([routerCommon])
          store.commit('permission/updateHasRule', true)
          const homePage = store.state.permission.homePage
          // 判断是否输入空地址，若为空且已经登录则跳转首页
          if (to.path === '/') {
            next({ path: homePage, replace: true })
          } else {
            next({ ...to, replace: true })
          }
        } else {
          next({ name: '登录' })
        }
      })
    } else {
      if (to.name === '登录') {
        store.commit('permission/updateHasRule', false)
      }
      next()
    }
  } else {
    next({ name: '登录' })
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js